var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5655 0.174997C15.8811 0.393747 16.0467 0.771872 15.9873 1.15L13.9873 14.15C13.9405 14.4531 13.7561 14.7187 13.4873 14.8687C13.2186 15.0187 12.8967 15.0375 12.6123 14.9187L8.87484 13.3656L6.73421 15.6812C6.45609 15.9844 6.01859 16.0844 5.63421 15.9344C5.24984 15.7844 4.99984 15.4125 4.99984 15V12.3875C4.99984 12.2625 5.04671 12.1437 5.13109 12.0531L10.3686 6.3375C10.5498 6.14062 10.5436 5.8375 10.3561 5.65C10.1686 5.4625 9.86546 5.45 9.66859 5.62812L3.31234 11.275L0.552962 9.89375C0.221712 9.72812 0.00921221 9.39687 -0.000162795 9.02812C-0.0095378 8.65937 0.184212 8.31562 0.502962 8.13125L14.503 0.131247C14.8373 -0.0593776 15.2498 -0.0406276 15.5655 0.174997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.78d87e25b33703cdf6038c2f47061d95.svg";
export { ForwardRef as ReactComponent };